/**
 * These mappings were originally ported over from Tag but it's still unclear whether it should be considered the "source of truth"
 */
export const colorFamilyToTokenBackgroundColor = {
  calypso: 'fill-accent-blue-subtle-alt',
  'candy-apple': 'fill-accent-red-subtle-alt',
  heffalump: 'fill-inverse-subtle',
  koala: 'fill-accent-neutral-subtle-alt',
  lorax: 'fill-accent-orange-subtle-alt',
  marigold: 'fill-accent-yellow-subtle-alt',
  norman: 'fill-accent-magenta-subtle-alt',
  olaf: 'icon-core-subtle',
  oz: 'fill-accent-green-subtle-alt',
  pantera: 'fill-accent-neutral-subtle-alt',
  sorbet: 'fill-accent-light-orange-subtle-alt',
  thunderdome: 'fill-accent-purple-subtle-alt'
};

/**
 * These mappings were originally ported over from Tag but it's still unclear whether it should be considered the "source of truth"
 */
export const colorFamilyToTokenBorderColor = {
  calypso: 'border-accent-blue-default',
  'candy-apple': 'border-accent-red-default',
  heffalump: 'fill-accent-neutral-default',
  koala: 'fill-tertiary-default',
  lorax: 'border-accent-orange-default',
  marigold: 'border-accent-yellow-default',
  norman: 'border-accent-magenta-default',
  olaf: 'icon-core-subtle',
  oz: 'border-accent-green-default',
  pantera: 'fill-accent-neutral-default',
  sorbet: 'fill-accent-light-orange-default',
  thunderdome: 'border-accent-purple-default'
};